import { updateObject } from "utils/helpers/updateObject";
import { actionTypes, CommercialDataReport,  FetchCommercialTotalUserByFilterFailureAction,  FetchCommercialTotalUserByFilterRequestAction,  FetchCommercialTotalUserByFilterSuccessAction,  FetchCommercialTotalUserFailureAction,  FetchCommercialTotalUserRequestAction,  FetchCommercialTotalUserSuccessAction,  FetchMembershipCountFailureAction,  FetchMembershipCountRequestAction,  FetchMembershipCountSuccessAction,  ResetCommercialFilterDataAction,  stateStatusType } from "./actionType";
import {CommercialTotalUserState, initialState } from "./state";

const FetchCommercialTotalUsersRequest = (
  state: CommercialTotalUserState,
  action: FetchCommercialTotalUserRequestAction
) => {
  return updateObject(state, {
    commercialTotalUsersState: {
      ...state.commercialTotalUsersState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const FetchCommercialTotalUsersSuccess = (
  state: CommercialTotalUserState,
  action: FetchCommercialTotalUserSuccessAction
) => {
  return updateObject(state, {
    commercialTotalUsersState: {
      ...state.commercialTotalUsersState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      dcddTotalUser: action.payload,
    },
  });
};

const FetchCommercialTotalUsersFail = (
  state: CommercialTotalUserState,
  action: FetchCommercialTotalUserFailureAction
) => {
  return updateObject(state, {
    commercialTotalUsersState: {
      ...state.commercialTotalUsersState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
      dcddTotalUser: null,
    },
  });
};


const FetchCommercialTotalUsersByFiterRequest = (
  state: CommercialTotalUserState,
  action: FetchCommercialTotalUserByFilterRequestAction
) => {
  return updateObject(state, {
    commercialTotalUserByFilterState: {
      ...state.commercialTotalUserByFilterState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const FetchCommercialTotalUsersByFiterSuccess = (
  state: CommercialTotalUserState,
  action: FetchCommercialTotalUserByFilterSuccessAction
) => {
  return updateObject(state, {
    commercialTotalUserByFilterState: {
      ...state.commercialTotalUserByFilterState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      dcddTotalUserByFilter: action.payload,
    },
  });
};

const FetchCommercialTotalUsersByFiterFail = (
  state: CommercialTotalUserState,
  action: FetchCommercialTotalUserByFilterFailureAction
) => {
  return updateObject(state, {
    commercialTotalUserByFilterState: {
      ...state.commercialTotalUserByFilterState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
      dcddTotalUserByFilter: null,
    },
  });
};
const FetchMembershipCountRequest = (
  state: CommercialTotalUserState,
  action: FetchMembershipCountRequestAction
) => {
  return updateObject(state, {
    membershipCountState: {
      ...state.membershipCountState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const FetchMembershipCountSuccess = (
  state: CommercialTotalUserState,
  action: FetchMembershipCountSuccessAction
) => {
  return updateObject(state, {
    membershipCountState: {
      ...state.membershipCountState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      membershipCount: action.payload,
    },
  });
};

const FetchMembershipCountFail = (
  state: CommercialTotalUserState,
  action: FetchMembershipCountFailureAction
) => {
  return updateObject(state, {
    membershipCountState: {
      ...state.membershipCountState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
      membershipCount: null,
    },
  });
};


//reset 
const resetDcddFiterData = (state: CommercialTotalUserState, action:ResetCommercialFilterDataAction) => ({
  ...state,
  commercialTotalUserByFilterState:{...initialState.commercialTotalUserByFilterState}

});

const commercialTotalDataReducer = (
  state = initialState,
  action: CommercialDataReport
) => {
  switch (action.type) {
    case actionTypes.FETCH_COMMERCIAL_TOTAL_USER_REQUEST:
      return FetchCommercialTotalUsersRequest(state, action);
    case actionTypes.FETCH_COMMERCIAL_TOTAL_USER_SUCCESS:
      return FetchCommercialTotalUsersSuccess(state, action);
    case actionTypes.FETCH_COMMERCIAL_TOTAL_USER_FAIL:
      return FetchCommercialTotalUsersFail(state, action);
    case actionTypes.FETCH_COMMERCIAL_TOTAL_USER_BY_FILTER_REQUEST:
      return FetchCommercialTotalUsersByFiterRequest(state, action);
    case actionTypes.FETCH_COMMERCIAL_TOTAL_USER_BY_FILTER_SUCCESS:
      return FetchCommercialTotalUsersByFiterSuccess(state, action);
    case actionTypes.FETCH_COMMERCIAL_TOTAL_USER_BY_FILTER_FAIL:
      return FetchCommercialTotalUsersByFiterFail(state, action);
    case actionTypes.FETCH_FETCH_MEMBERSHIP_COUNT_REQUEST:
      return FetchMembershipCountRequest(state, action);
    case actionTypes.FETCH_FETCH_MEMBERSHIP_COUNT_SUCCESS:
      return FetchMembershipCountSuccess(state, action);
    case actionTypes.FETCH_FETCH_MEMBERSHIP_COUNT_FAIL:
      return FetchMembershipCountFail(state, action);
    case actionTypes.RESET_COMMERCIAL_FILTER_DATA:
      return resetDcddFiterData(state, action);
    default:
      return state;
  }
};
export default commercialTotalDataReducer;

